import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { VersionInfos } from '@models/VersionInfos';
import { BaseService } from '@shared/services/base.service';
import { LoadingService } from '@shared/services/loading.service';
import { BaseComponent } from '../base-component';

@Component({
  selector: 'pop-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.less']
})
export class AboutComponent extends BaseComponent implements OnInit {
  public version?: VersionInfos;

  public constructor(private http: HttpClient, private loadingService: LoadingService) {
    super();
  }

 public ngOnInit(): void {
    this.setVersion();
  }

  private setVersion() {
    this.loadingService.setIsLoading(true);

    this.subscribe(
      this.http.get<VersionInfos>(BaseService.getBaseUrl() + '/breeze/version/get').subscribe(version => {
        this.version = version;
        this.loadingService.setIsLoading(false);
      })
    );
  }
}
